module.exports = __webpack_public_path__ + "img/rectangle-c.7d2b3ac0.svg";